import React, {FunctionComponent} from 'react';
import './AndroidButton.less';
import {SvgIcon} from '../../../images/types';

interface AndroidButtonProps {
	icon: SvgIcon,
	text: string,
	onClick: () => void
}

export const AndroidButton: FunctionComponent<AndroidButtonProps> = ({icon, text, onClick}) => {
	return <button className="android-button" onClick={onClick}>
		<span className="android-button__icon" dangerouslySetInnerHTML={{__html: icon}}></span>
		<span className="android-button__text">{text}</span>
	</button>;
};

